const generateInformation = (translate) => {
  return {
    title: translate('routes.routeBatch.titulo'),
    subtitle: translate('routes.routeBatch.subtitulo'),
    fileNameBasis: 'lastmile_batch_routes',
  };
};

const generateLocalization = (translate) => {
  return {
    buttons: {
      plantilla: translate('routes.excelLoader.buttons.plantilla'),
      exportar: translate('routes.excelLoader.buttons.exportar'),
      importar: translate('routes.excelLoader.buttons.importar'),
      guardar: translate('routes.excelLoader.buttons.guardar'),
    },
    pills: {
      duplicated: translate('routes.excelLoader.pills.duplicated'),
    },
    successMessage: translate('routes.excelLoader.successMessage'),
  };
};
const generateMassiveRouteSchema = (countries, spots, activityTypes, itemTypes, translate, obtainAddress, tags, drivers, vehicles) => {
  //TODO: mostrar solo sedes propias para las bases (rutas)
  /* var spotsRoute = spots.filter(function (el) {
    return el.type == "Sede propia";
  }); */

  let spotSliced = spots;
  if (spots.length > 500) {
    spotSliced = spots.slice(0, 500);
  }

  let itemSliced = itemTypes;
  if (itemTypes.length > 500) {
    itemSliced = itemTypes.slice(0, 500);
  }

  let driverSliced = drivers;
  if (drivers.length > 500) {
    driverSliced = drivers.slice(0, 500);
  }

  let vehicleSliced = vehicles;
  if (vehicles.length > 500) {
    vehicleSliced = vehicles.slice(0, 500);
  }

  let spotDestination = [{ name: translate('routes.routeBatch.campos.temporalSpot') }, ...spotSliced];

  return [
    {
      key: 'name',
      label: translate('routes.routeBatch.campos.routeName'),
      type: 'text',
      unique: true,
      required: true,
    },
    {
      key: 'origin',
      label: translate('routes.routeBatch.campos.origin'),
      type: 'dropdown-reduced-view',
      width: '250px',
      options: spotSliced.map((o) => {
        let spot;
        if (o) {
          if (o.type !== 'Temporal') {
            spot = o.name;
          } else {
            const splitAddress = o.name.split(',');
            spot = `${splitAddress[0]}, ${splitAddress[1]}`;
          }
        } else {
          spot = '-';
        }
        return spot;
      }),
      optionsFull: spots.map((o) => {
        let spot;
        if (o) {
          if (o.type !== 'Temporal') {
            spot = o.name;
          } else {
            const splitAddress = o.name.split(',');
            spot = `${splitAddress[0]}, ${splitAddress[1]}`;
          }
        } else {
          spot = '-';
        }
        return spot;
      }),
      required: true,
    },
    {
      key: 'startDate',
      label: translate('routes.routeBatch.campos.startDate'),
      type: 'date',
      required: true,
    },
    {
      key: 'startTime',
      label: translate('routes.routeBatch.campos.startTime'),
      type: 'time',
      required: true,
    },
    {
      key: 'loadTime',
      label: translate('routes.routeBatch.campos.loadTime'),
      type: 'number',
    },
    {
      key: 'unloadTime',
      label: translate('routes.routeBatch.campos.unloadtime'),
      type: 'number',
    },
    {
      key: 'trips',
      label: translate('routes.routeBatch.sheets.trips'),
      type: 'worksheet',
      foreignKey: 'name',
      innerSchema: [
        {
          key: 'tripNumber',
          label: translate('routes.routeBatch.campos.tripNumber'),
          autoincremental: true,
          type: 'number',
          required: true,
          unique: true,
        },
        {
          key: 'tripDestination',
          label: translate('routes.routeBatch.campos.destination'),
          type: 'dropdown-reduced-view',
          width: '250px',
          options: spotDestination.map((o) => {
            let spot;
            if (o) {
              if (o.type !== 'Temporal') {
                spot = o.name;
              } else {
                const splitAddress = o.name.split(',');
                spot = `${splitAddress[0]}, ${splitAddress[1]}`;
              }
            } else {
              spot = '-';
            }
            return spot;
          }),
          required: true,
          optionsFull: [{ name: translate('routes.routeBatch.campos.temporalSpot') }, ...spots].map((o) => {
            let spot;
            if (o) {
              if (o.type !== 'Temporal') {
                spot = o.name;
              } else {
                const splitAddress = o.name.split(',');
                spot = `${splitAddress[0]}, ${splitAddress[1]}`;
              }
            } else {
              spot = '-';
            }
            return spot;
          }),
        },
        {
          key: 'timeEdit',
          label: translate('routes.routeBatch.campos.timeEdit'),
          type: 'number',
        },
        {
          key: 'operator',
          label: translate('routes.routeBatch.campos.operator'),
          type: 'dropdown-reduced-view',
          width: '250px',
          options: driverSliced.map((o) => {
            let driver;
            if (o) {
              driver = o.fullNameAndClient;
            } else {
              driver = '-';
            }
            return driver;
          }),
          optionsFull: drivers.map((o) => {
            let driver;
            if (o) {
              driver = o.fullNameAndClient;
            } else {
              driver = '-';
            }
            return driver;
          }),
          required: false,
        },
        {
          key: 'vehicle',
          label: translate('routes.routeBatch.campos.vehicle'),
          type: 'dropdown-reduced-view',
          width: '250px',
          options: vehicleSliced.map((o) => {
            let vehicle;
            if (o) {
              vehicle = o.plateAndClient;
            } else {
              vehicle = '-';
            }
            return vehicle;
          }),
          optionsFull: vehicles.map((o) => {
            let vehicle;
            if (o) {
              vehicle = o.plateAndClient;
            } else {
              vehicle = '-';
            }
            return vehicle;
          }),
          required: false,
        },
        {
          key: 'Street',
          label: translate('routes.routeBatch.campos.street'),
          type: 'text',
          disabled: (fullRow) => {
            return fullRow.tripDestination &&
              fullRow.tripDestination.length &&
              fullRow.tripDestination === translate('routes.routeBatch.campos.temporalSpot')
              ? false
              : true;
          },
        },
        {
          key: 'City',
          label: translate('routes.routeBatch.campos.city'),
          type: 'text',
          disabled: (fullRow) => {
            return fullRow.tripDestination &&
              fullRow.tripDestination.length &&
              fullRow.tripDestination === translate('routes.routeBatch.campos.temporalSpot')
              ? false
              : true;
          },
        },
        {
          key: 'State',
          label: translate('routes.routeBatch.campos.state'),
          type: 'text',
          disabled: (fullRow) => {
            return fullRow.tripDestination &&
              fullRow.tripDestination.length &&
              fullRow.tripDestination === translate('routes.routeBatch.campos.temporalSpot')
              ? false
              : true;
          },
        },
        {
          key: 'Country',
          label: translate('routes.routeBatch.campos.country'),
          type: 'dropdown',
          options: countries.map((c) => c.name),
          disabled: (fullRow) => {
            return fullRow.tripDestination &&
              fullRow.tripDestination.length &&
              fullRow.tripDestination === translate('routes.routeBatch.campos.temporalSpot')
              ? false
              : true;
          },
        },
        {
          key: 'Address',
          label: translate('routes.routeBatch.campos.address'),
          type: 'readonly',
          expectedValue: async (fullRow) => {
            if (fullRow.tripDestination && fullRow.tripDestination.length) {
              if (fullRow.tripDestination != translate('routes.routeBatch.campos.temporalSpot')) {
                try {
                  const currentSpot = spots.find((s) => {
                    //Verifico si el spot del listado es temporal
                    if (s.type !== 'Temporal' && s.name === fullRow.tripDestination) {
                      return s;
                    }
                    //Si es temporal entonces transformo el nombre del spot
                    else if (s.type === 'Temporal') {
                      const splitAddress = s.name.split(',');
                      const newName = `${splitAddress[0]}, ${splitAddress[1]}`;
                      if (newName === fullRow.tripDestination) {
                        return s;
                      }
                    }
                  });
                  if (currentSpot == undefined) {
                    return null;
                  }
                  const address = await obtainAddress(currentSpot.id);
                  return address.street + ', ' + address.city + ', ' + address.state;
                } catch (e) {
                  console.log(e);
                  return '';
                }
              } else {
                let street = fullRow.Street != '' ? fullRow.Street : '';
                let city = fullRow.City != '' ? ', ' + fullRow.City : '';
                let state = fullRow.State != '' ? ', ' + fullRow.State : '';
                let country = fullRow.Country != '' ? ', ' + fullRow.Country : '';
                return street + city + state + country;
              }
            } else {
              return '';
            }
          },
        },
        {
          key: 'activities',
          label: translate('routes.routeBatch.sheets.activities'),
          type: 'worksheet',
          foreignKey: 'tripNumber',
          innerSchema: [
            {
              key: 'activityName',
              label: translate('routes.routeBatch.campos.activityName'),
              type: 'text',
              required: true,
            },
            {
              key: 'activityNumber',
              label: translate('routes.routeBatch.campos.activityNumber'),
              autoincremental: true,
              type: 'number',
              required: true,
              unique: true,
            },
            {
              key: 'activityType',
              label: translate('routes.routeBatch.campos.activityType'),
              type: 'dropdown',
              options: activityTypes.map((o) => o.text),
              required: true,
            },
            {
              key: 'duration',
              label: translate('routes.routeBatch.campos.duration'),
              type: 'number',
              required: true,
            },
            {
              key: 'volume',
              label: translate('routes.routeBatch.campos.volume'),
              type: 'number',
            },
            {
              key: 'weight',
              label: translate('routes.routeBatch.campos.weight'),
              type: 'number',
            },
            {
              key: 'tag',
              label: translate('routes.routeBatch.campos.tag'),
              type: 'dropdown',
              options: tags.map((t) => t.name),
            },
            {
              key: 'customerName',
              label: translate('routes.routeBatch.campos.customerName'),
              type: 'text',
              disabled: (fullRow) => {
                return fullRow.activityType &&
                  fullRow.activityType.length &&
                  fullRow.activityType === translate('activities.formulario.campos.typeOptions.DELIVERY')
                  ? false
                  : true;
              },
            },
            {
              key: 'customerLegalNumber',
              label: translate('routes.routeBatch.campos.customerLegalNumber'),
              type: 'text',
              disabled: (fullRow) => {
                return fullRow.activityType &&
                  fullRow.activityType.length &&
                  fullRow.activityType === translate('activities.formulario.campos.typeOptions.DELIVERY')
                  ? false
                  : true;
              },
            },
            {
              key: 'customerPhone',
              label: translate('routes.routeBatch.campos.customerPhone'),
              type: 'text',
              disabled: (fullRow) => {
                return fullRow.activityType &&
                  fullRow.activityType.length &&
                  fullRow.activityType === translate('activities.formulario.campos.typeOptions.DELIVERY')
                  ? false
                  : true;
              },
            },
            {
              key: 'email',
              label: translate('routes.routeBatch.campos.customerEmail'),
              type: 'text',
              disabled: (fullRow) => {
                return fullRow.activityType &&
                  fullRow.activityType.length &&
                  fullRow.activityType === translate('activities.formulario.campos.typeOptions.DELIVERY')
                  ? false
                  : true;
              },
            },
            {
              key: 'documents',
              label: translate('routes.routeBatch.sheets.documents'),
              type: 'worksheet',
              foreignKey: 'activityNumber',
              innerSchema: [
                {
                  key: 'documentNumber',
                  label: translate('routes.routeBatch.campos.documentNumber'),
                  type: 'text',
                  required: true,
                  unique: true,
                },
                {
                  key: 'items',
                  label: translate('routes.routeBatch.sheets.items'),
                  type: 'worksheet',
                  foreignKey: 'documentNumber',
                  innerSchema: [
                    {
                      key: 'itemType',
                      label: translate('routes.routeBatch.campos.itemType'),
                      type: 'dropdown-reduced-view',
                      options: itemSliced.map((o) => o.name),
                      optionsFull: itemTypes.map((o) => o.name),
                      required: true,
                    },
                    {
                      key: 'code',
                      label: translate('routes.routeBatch.campos.code'),
                      type: 'readonly',
                      expectedValue: async (fullRow) => {
                        if (fullRow.itemType && fullRow.itemType.length) {
                          try {
                            const currentItem = itemTypes.find((o) => o.name === fullRow.itemType);
                            if (currentItem == undefined) {
                              return '';
                            }
                            return currentItem.code;
                          } catch (e) {
                            console.log(e);
                            return '';
                          }
                        } else {
                          return '';
                        }
                      },
                    },
                    {
                      key: 'itemQuantity',
                      label: translate('routes.routeBatch.campos.quantity'),
                      type: 'number',
                      required: true,
                    },
                    {
                      key: 'itemUnitPrice',
                      label: translate('routes.routeBatch.campos.unitPrice'),
                      type: 'number',
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ];
};

export { generateMassiveRouteSchema, generateLocalization, generateInformation };
